import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { GetProjectReportList, UpdateProjectReportStatus } from "../../Redux/Actions/projectReportActions";
import { columnsProjectReportList } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ListProjectReport = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
    const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

    const projectReportState = useSelector((state) => state.projectReport || {});
    console.log("datta",projectReportState)
    const projectReports = projectReportState.projectReports?.data || [];
    const reportTotal = projectReportState.total || 0;
    const { loading } = projectReportState;

    const fetchDetails = useCallback(
        (page = pagination.current, pageSize = pagination.pageSize) => {
            const payload = {
                page,
                limit: pageSize,
                ...(debouncedSearch && { filter: debouncedSearch }),
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };
            return dispatch(GetProjectReportList(payload)).catch(() => {
                toast.error("Failed to fetch project report list");
            });
        },
        [dispatch, debouncedSearch, dateRange, pagination.current, pagination.pageSize]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, fetchDetails]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
    }, [debouncedSearch, dateRange]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, total: reportTotal }));
    }, [reportTotal]);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedSearch(searchQuery), 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (newPagination) => setPagination(newPagination);

    const handleDateRangeApply = (start, end) => {
        setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleStatusChange = async (record, action) => {
        await dispatch(UpdateProjectReportStatus(record._id, action));
        fetchDetails(pagination.current, pagination.pageSize);
    };

    return (
        <MainLayout>
            <div className="bookings_table">
                <div className="table_component_all">

                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading="Project Reports"
                            setState={setSearchQuery}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                        <div style={{ position: "static", marginTop: "-6%", marginLeft: "85.4%", marginBottom: "23px" }}>
                            {canAdd && (
                                <button
                                    style={{ background: "#070C18", color: "white", padding: "12px", borderRadius: "20px" }}
                                    onClick={() => navigate("/project_report/add")}
                                >
                                    Add Report
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="custom_table">
                        <div style={{ width: "90%" }}>
                            <Table
                                dataSource={Array.isArray(projectReports) ? projectReports : []}
                                virtual
                                scroll={{ x: 1200, y: 500 }}
                                pagination={pagination}
                                onChange={handleTableChange}
                                loading={loading}
                                columns={columnsProjectReportList(
                                    pagination.current,
                                    pagination.pageSize,
                                    fetchDetails,
                                    canEdit,
                                    handleStatusChange
                                )}
                                rowClassName={() => "text-center"}
                            />
                        </div>
                    </div>

                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </MainLayout>
    );
};

export default ListProjectReport;